export default __webpack_public_path__ + "static/media/background.39b186a3.jpeg";